import { useReactiveVar } from "@apollo/client";
import { memo, useCallback, useMemo, useState } from "react";
import * as Styled from "./style";
import { DMM_SERVICE_MENU } from "~/components/blocks/layout/global-navi/const/dmm-service-menu";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { NaviItem } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service/navi-list/navi-item";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { COOKIE } from "~/const/cookie";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { getCookie } from "~/util/get-cookie";

type NavItem = {
  name: string;
  src: string;
  href: string;
  data_link: string;
  isNew: boolean;
};

/**
 * TODO: (okita) グロナビ新APIが本番に反映後ディレクトリ
 */
export const OldNaviList = memo(() => {
  const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);
  // アダルト導線を非表示にするcookieが設定されている場合その他を取り除く
  const adultLinkDisable = getCookie(COOKIE.ADULT_LINK_DISABLE.KEY);

  const [isOpenMore, setIsOpenMore] = useState(false);
  const openMore = useCallback(() => setIsOpenMore(true), []);

  const dmmServiceList = useMemo(() => {
    const defaultData: NavItem[] = dmmServiceListData.map(({ name, href, src, data_link, isNew }) => ({
      name,
      href,
      src,
      data_link,
      isNew,
    }));

    const firstRow = defaultData.slice(0, 13);
    let secondRow = defaultData.slice(13, defaultData.length);
    if (!isOpenMore) return [firstRow, secondRow, [] as NavItem[]];

    // その他を削除したリスト
    const filterOtherDataList = defaultData.filter((data) => data.name !== DMM_SERVICE_MENU.OTHER_SERVICE);

    // その他サービスを押下後に表示する値を抽出
    const otherData = dmmServiceListData.find((data) => data.name === DMM_SERVICE_MENU.OTHER_SERVICE);
    if (!otherData) return [firstRow, secondRow, [] as NavItem[]];
    const openMoreList: NavItem[] = otherData.floors.map(({ name, href, src, data_link, isNew }) => ({
      name,
      href,
      src,
      data_link,
      isNew,
    }));

    // 既存リストとその他サービスを結合
    const concatList = filterOtherDataList.concat(openMoreList);
    secondRow = concatList.slice(13, 27);
    const thirdRow = concatList.slice(27, concatList.length);

    return [firstRow, secondRow, thirdRow];
  }, [dmmServiceListData, isOpenMore]);

  return (
    <>
      <Styled.DivGlobalColumn>
        <Styled.Anchor
          href={URL.top}
          onClick={() => sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "dmmtop" })}
        >
          DMM.com トップへ
        </Styled.Anchor>
        <ul>
          {dmmServiceList[0].map((item, idx) => (
            <NaviItem
              key={item.name}
              src={item.src}
              text={item.name}
              href={item.href}
              viaViewRank={idx + 1}
              viaTargetId={item.data_link}
              isNew={item.isNew}
            />
          ))}
        </ul>
      </Styled.DivGlobalColumn>

      <Styled.DivGlobalColumn>
        <ul>
          <>
            {dmmServiceList[1].map((item, idx) => {
              return item.name !== DMM_SERVICE_MENU.OTHER_SERVICE ? (
                <NaviItem
                  key={item.name}
                  src={item.src}
                  text={item.name}
                  href={item.href}
                  viaViewRank={idx + 1}
                  viaTargetId={item.data_link}
                  isNew={item.isNew}
                />
              ) : (
                <NaviItem
                  key={item.name}
                  src={item.src}
                  text={item.name}
                  onItemPressed={openMore}
                  viaViewRank={idx + 1}
                  viaTargetId={item.data_link}
                  isNew={item.isNew}
                />
              );
            })}

            {!isOpenMore && adultLinkDisable === undefined && (
              <Styled.Anchor
                isAdult
                href={URL.fanza}
                onClick={() => sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "fanzatop" })}
              >
                成人向けへ (FANZA)
              </Styled.Anchor>
            )}
          </>
        </ul>
      </Styled.DivGlobalColumn>

      {/* ３列目 */}
      {isOpenMore && (
        <Styled.DivGlobalColumn>
          <ul>
            {dmmServiceList[2].map((item, idx) => (
              <NaviItem
                key={item.name}
                src={item.src}
                text={item.name}
                href={item.href}
                viaViewRank={idx + 1}
                viaTargetId={item.data_link}
                isNew={item.isNew}
              />
            ))}
            {adultLinkDisable === undefined && (
              <Styled.Anchor
                isAdult
                href={URL.fanza}
                onClick={() => sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "fanzatop" })}
              >
                成人向けへ (FANZA)
              </Styled.Anchor>
            )}
          </ul>
        </Styled.DivGlobalColumn>
      )}
    </>
  );
});

OldNaviList.displayName = "OldNaviList";
